let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("hxiOL")]).then(() => parcelRequire('6QJpB'));